import _typeof from "/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/esm/typeof.js";
import _asyncToGenerator from "/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.flat.js";
import "core-js/modules/es.array.unscopables.flat.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.test.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url.js";
import "core-js/modules/web.url-search-params.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/es.string.replace.js";
import { ModalComponents, ModalStatus } from "@/constants/modal";
import ModalModule from "@/store/modules/modal";
import { CustomFieldType, QuestionType, InformationType, CustomFieldValidation } from "@/types/db/product-category";
import { bookingCustomFields, startProcessing } from "@/utils/vue-helpers/booking";
import { dialogVisibleForStatus } from "@/utils/vue-helpers/modal";
import MazPhoneNumberInput from "maz-ui/components/MazPhoneNumberInput";
import { parsePhoneNumber } from "libphonenumber-js";
import { computed, defineComponent, ref } from "vue";
import { useI18n } from "vue-i18n";
import { cloneDeep } from "lodash";
import CommonModule from "@/store/modules/common";
import BookingModule from "@/store/modules/booking";
import { createCompositeId } from "@/utils/helpers/app";
import dayjs from "dayjs";
import { insertFile } from "@/utils/helpers/db";
import binSvg from "@/assets/images/svg/bin-svgrepo-com.svg";
import VueCropper from "vue-cropperjs";
import "cropperjs/dist/cropper.css";
import CustomersModule from "@/store/modules/customers";
import POSConfigModule from "@/store/modules/pos-config";
var ValidationDataType;

(function (ValidationDataType) {
  ValidationDataType[ValidationDataType["Number"] = 1] = "Number";
  ValidationDataType[ValidationDataType["Email"] = 2] = "Email";
})(ValidationDataType || (ValidationDataType = {}));

export default defineComponent({
  name: ModalComponents.CustomFields,
  components: {
    MazPhoneNumberInput: MazPhoneNumberInput,
    VueCropper: VueCropper
  },
  setup: function setup() {
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
      var _BookingModule$select;

      var _useI18n, t, phoneValidationResults, dialogVisible, isLoading, canValidate, selectedFiles, cropperRef, bookingTypeCustomFields, priceCategoryData, binIcon, binAlt, binIconStyle, _bookingCustomFields$, i, ticketTypeCustomFields, groupedTicketTypeCustomFieldsByPSS, _bookingCustomFields$2, _loop, _i, showPriceCategory, selectedPriceCategory, displayedCustomFieldsType, userCurrentCountry, getCountryCodeFromPhone, computedDisplayedCustomFieldsType, canConfirm, isEmailValid, selectBookingTypeCustomFields, selectTicketTypeCustomFields, checkPhoneNumber, countriesList, languagesList, selectPriceCategory, handleFileUpload, removeFile, confirmCroppedPicture, cancelCroppedPicture, stripHtml, frequentlySelectedCountries, searchQuery, showFrequentlySelected, countryFilter, filteredCountriesList, handleDropdownVisibility, getFlagUrl;

      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              stripHtml = function _stripHtml(val) {
                return val.replace(/<[^>]+>/g, "").trim();
              };

              cancelCroppedPicture = function _cancelCroppedPicture(cust) {
                cust.answer = "";
                cust.fileID = "";
                cust.fileUrl = "";
              };

              confirmCroppedPicture = function _confirmCroppedPictur(cust) {
                console.log("this.$refs.cropperRef");
                console.log(this.$refs[cust.uuid + "_cropper"]);
                console.log("this.$refs[cust.uuid+'_cropper'][0]");
                console.log(this.$refs[cust.uuid + "_cropper"][0]); ////
                // THIS IS BASE 64 IMAGE
                // const croppedData = this.$refs.cropperRef[0].getCroppedCanvas().toDataURL();
                // console.log("croppedData");
                // console.log(croppedData);
                ////
                // THIS IS BASE 64 IMAGE
                // console.log("going to export the image");
                // const img = (this.$refs.cropperRef[0] as any).getCroppedCanvas().toDataURL('image/jpeg');
                // console.log("done exporting the image");
                // console.log("img");
                // console.log(img);
                ////
                // Get the cropped file as blob, And push it to selectedFiles array, And display it to the user, And destroy cropper

                this.$refs[cust.uuid + "_cropper"][0].getCroppedCanvas().toBlob(function (blob) {
                  var cropedFile = new File([blob], String(cust.fileID + "hola")); // const fileField = bookingTypeCustomFields.value.find(
                  //   (c) => c.uuid === cust.uuid
                  // );

                  var fileField = cust;

                  if (fileField) {
                    fileField.fileID = createCompositeId([dayjs().toISOString()]);
                    fileField.answer = fileField.fileID; // Lets keep a url for the image so that it can be displayed

                    fileField.fileUrl = URL.createObjectURL(blob);
                    selectedFiles.push({
                      id: fileField.fileID,
                      file: cropedFile
                    });
                    cust.fileUrl = fileField.fileUrl;
                    cust.isCropped = true;
                  }
                }, "image/jpeg"); // Lets now destroy the cropper

                this.$refs[cust.uuid + "_cropper"][0].destroy(); // Hide cropping are and keep only the img element displaying the cropped image
                //cust.uuid+'_cropper'

                var cropperParent = this.$refs[cust.uuid + "_cropper_parent"][0]; // hiding cropper parent

                cropperParent.style.display = "none"; ////
              };

              removeFile = function _removeFile(cust) {
                cust.fileUrl = "";
                cust.fileID = "";
                cust.answer = "";
                cust.isCropped = false;
              };

              handleFileUpload = function _handleFileUpload(event, customFieldUuid, type) {
                var file = event.target.files[0]; // Now lets fill the file name into 'answer' field based on whether we are in Ticket custom fields or Booking custom fields

                if (type === CustomFieldType.BOOKING) {
                  var fileField = bookingTypeCustomFields.value.find(function (c) {
                    return c.uuid === customFieldUuid;
                  });

                  if (fileField) {
                    fileField.isInvalid = false;
                    fileField.validationMessage = "";
                    var fileSize = file.size;

                    if (fileSize > 10485760) {
                      fileField.isInvalid = true;
                      fileField.validationMessage = "File should be less than 10 mb";
                      return;
                    }

                    fileField.answer = file.name;
                    fileField.fileID = createCompositeId([dayjs().toISOString(), file.name]);
                    var reader = new FileReader();

                    reader.onload = /*#__PURE__*/function () {
                      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(ev) {
                        var fileData, blob;
                        return regeneratorRuntime.wrap(function _callee$(_context) {
                          while (1) {
                            switch (_context.prev = _context.next) {
                              case 0:
                                fileData = ev.target.result;
                                blob = new Blob([file], {
                                  type: file.type
                                }); // Lets keep a url for the image so that it can be displayed

                                fileField.fileUrl = URL.createObjectURL(blob);
                                selectedFiles.push({
                                  id: fileField.fileID,
                                  file: blob
                                });

                              case 4:
                              case "end":
                                return _context.stop();
                            }
                          }
                        }, _callee);
                      }));

                      return function (_x) {
                        return _ref.apply(this, arguments);
                      };
                    }();

                    reader.readAsBinaryString(file);
                  }
                }

                if (type === CustomFieldType.TICKET) {
                  var _fileField = groupedTicketTypeCustomFieldsByPSS.value.map(function (g) {
                    return g.customFields;
                  }).flat().find(function (c) {
                    return c.uuid === customFieldUuid;
                  });

                  if (_fileField) {
                    _fileField.isInvalid = false;
                    _fileField.validationMessage = "";
                    var _fileSize = file.size;

                    if (_fileSize > 10485760) {
                      _fileField.isInvalid = true;
                      _fileField.validationMessage = "File should be less than 10 mb";
                      return;
                    }

                    _fileField.answer = file.name;
                    _fileField.fileID = createCompositeId([dayjs().toISOString(), file.name]);

                    var _reader = new FileReader();

                    _reader.onload = /*#__PURE__*/function () {
                      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(ev) {
                        var fileData, blob;
                        return regeneratorRuntime.wrap(function _callee2$(_context2) {
                          while (1) {
                            switch (_context2.prev = _context2.next) {
                              case 0:
                                fileData = ev.target.result;
                                blob = new Blob([file], {
                                  type: file.type
                                }); // Lets keep a url for the image so that it can be displayed

                                _fileField.fileUrl = URL.createObjectURL(blob);
                                selectedFiles.push({
                                  id: _fileField.fileID,
                                  file: blob
                                });

                              case 4:
                              case "end":
                                return _context2.stop();
                            }
                          }
                        }, _callee2);
                      }));

                      return function (_x2) {
                        return _ref2.apply(this, arguments);
                      };
                    }();

                    _reader.readAsBinaryString(file);
                  }
                }
              };

              selectPriceCategory = function _selectPriceCategory(priceCategory) {
                selectedPriceCategory.value = priceCategory;
              };

              languagesList = function _languagesList(customFieldList) {
                var languages = CommonModule.languages;
                var filteredLanguages = [];
                languages.filter(function (lang) {
                  return customFieldList.includes(lang.code);
                }).forEach(function (lang) {
                  filteredLanguages.push({
                    key: lang.code,
                    value: lang.name
                  });
                });
                return filteredLanguages;
              };

              countriesList = function _countriesList() {
                var countries = CommonModule.countries;
                var formattedCountries = [];

                for (var _i5 = 0; _i5 < countries.length; _i5++) {
                  formattedCountries.push({
                    key: countries[_i5].code,
                    value: countries[_i5].name
                  });
                }

                return formattedCountries;
              };

              checkPhoneNumber = function _checkPhoneNumber() {
                // We validate if there is avalue entered by the user
                if (phoneValidationResults.value) {
                  if (phoneValidationResults.value.nationalNumber) return phoneValidationResults.value.isValid;
                } // // We don't let the phone validator we're using assign undefined value to phone field when it has empty string
                // // beause it will never be considered and the user will never be able to empty a phone number from a customer
                // if (!ruleForm.phone) ruleForm.phone = "";
                // We don't validate if there is no phone entered


                return true;
              };

              selectTicketTypeCustomFields = function _selectTicketTypeCust() {
                displayedCustomFieldsType.value = CustomFieldType.TICKET;
                selectedPriceCategory.value = priceCategoryData.value[0];
              };

              selectBookingTypeCustomFields = function _selectBookingTypeCus() {
                displayedCustomFieldsType.value = CustomFieldType.BOOKING;
              };

              isEmailValid = function _isEmailValid(custAnswer) {
                var validationResult = {
                  isValid: true,
                  message: ""
                };

                if (custAnswer.customField.informationType === InformationType.EMAIL) {
                  // Lets validate the email using same regew used by vuelidate
                  // https://github.com/vuelidate/vuelidate/blob/%40vuelidate/validators%402.0.3/packages/validators/src/raw/email.js
                  var emailRegex = // eslint-disable-next-line no-control-regex
                  /^(?:[A-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[A-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9]{2,}(?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/i;
                  var res = emailRegex.test(custAnswer.answer);

                  if (res) {
                    validationResult.isValid = true;
                    validationResult.message = "";
                    return validationResult;
                  } else {
                    validationResult.isValid = false;
                    validationResult.message = "Email not valid";
                    return validationResult;
                  }
                }

                return validationResult;
              };

              _useI18n = useI18n({}), t = _useI18n.t;
              phoneValidationResults = ref();
              dialogVisible = dialogVisibleForStatus(ModalStatus.CustomFields);
              isLoading = ref(false);
              canValidate = ref(false);
              selectedFiles = [];
              cropperRef = ref(null);
              bookingTypeCustomFields = ref([]);
              priceCategoryData = ref([]);
              binIcon = binSvg;
              binAlt = "bin";
              binIconStyle = "width: 18px; height: 18px;"; // lets assign bookingTypeCustomFields the custom fields already attached to the booking

              if (!bookingCustomFields.value) {
                _context3.next = 42;
                break;
              }

              // Why clonning? We don't need the UI to be attached directly to answers of the booking and automatically be updated
              // we need the user to confirm his answers so we can attach them to the booking
              bookingTypeCustomFields.value = cloneDeep((_bookingCustomFields$ = bookingCustomFields.value) === null || _bookingCustomFields$ === void 0 ? void 0 : _bookingCustomFields$.filter(function (cust) {
                return cust.customField.customFieldType === CustomFieldType.BOOKING;
              }));
              console.log("------------- bookingTypeCustomFields.value");
              console.log(bookingTypeCustomFields.value); // Now lets iterate thru BookingCustomFields and check for
              // unanswered fields of type (firstName, lastName, Email, Address, Phone)
              // and see of the current booking has a customer assigned to it so that we prefill those unanswered fields

              if (!CustomersModule.getSelectedCustomerId) {
                _context3.next = 42;
                break;
              }

              i = 0;

            case 30:
              if (!(i < bookingTypeCustomFields.value.length)) {
                _context3.next = 42;
                break;
              }

              if (bookingTypeCustomFields.value[i].answer) {
                _context3.next = 38;
                break;
              }

              // This is an unanswered field
              if (bookingTypeCustomFields.value[i].customField.informationType === InformationType.FIRSTNAME) {
                bookingTypeCustomFields.value[i].answer = CustomersModule.getSelectedCustomerFirstName;
              }

              if (bookingTypeCustomFields.value[i].customField.informationType === InformationType.LASTNAME) {
                bookingTypeCustomFields.value[i].answer = CustomersModule.getSelectedCustomerLastName;
              }

              if (bookingTypeCustomFields.value[i].customField.informationType === InformationType.EMAIL) {
                bookingTypeCustomFields.value[i].answer = CustomersModule.getSelectedCustomerEmail;
              }

              if (bookingTypeCustomFields.value[i].customField.informationType === InformationType.ADDRESS) {
                bookingTypeCustomFields.value[i].answer = CustomersModule.getSelectedCustomerAddress;
              }

              _context3.next = 39;
              break;

            case 38:
              return _context3.abrupt("continue", 39);

            case 39:
              i++;
              _context3.next = 30;
              break;

            case 42:
              ticketTypeCustomFields = ref([]);
              groupedTicketTypeCustomFieldsByPSS = ref([]); // lets assign ticketTypeCustomFields the custom fields already attached to the pssList

              if (bookingCustomFields.value) {
                // Why clonning? We don't need the UI to be attached directly to answers of the booking and automatically be updated
                // we need the user to confirm his answers so we can attach them to the booking
                ticketTypeCustomFields.value = cloneDeep((_bookingCustomFields$2 = bookingCustomFields.value) === null || _bookingCustomFields$2 === void 0 ? void 0 : _bookingCustomFields$2.filter(function (cust) {
                  return cust.customField.customFieldType === CustomFieldType.TICKET;
                })); // lets now fill groupedTicketTypeCustomFieldsByPSS with custom fields grouped by PSS

                _loop = function _loop(_i) {
                  if (groupedTicketTypeCustomFieldsByPSS.value.findIndex(function (it) {
                    return it.pssUuid === ticketTypeCustomFields.value[_i].pssUuid;
                  }) < 0) {
                    // so this custom field doesn't exist yet, lets add it and add all custom fields related to the same pss
                    groupedTicketTypeCustomFieldsByPSS.value.push({
                      pssUuid: String(ticketTypeCustomFields.value[_i].pssUuid),
                      customFields: ticketTypeCustomFields.value.filter(function (cust) {
                        return cust.pssUuid === ticketTypeCustomFields.value[_i].pssUuid;
                      })
                    });
                  }
                };

                for (_i = 0; _i < ticketTypeCustomFields.value.length; _i++) {
                  _loop(_i);
                }
              } // Lets fill in priceCategoryData


              if ((_BookingModule$select = BookingModule.selectedBooking) !== null && _BookingModule$select !== void 0 && _BookingModule$select.pssList) {
                (function () {
                  var _BookingModule$select2;

                  // consider only pss with custom fields
                  var pssList = (_BookingModule$select2 = BookingModule.selectedBooking) === null || _BookingModule$select2 === void 0 ? void 0 : _BookingModule$select2.pssList.filter(function (p) {
                    return p.customFieldsAnswers && p.customFieldsAnswers.length;
                  });

                  var _loop2 = function _loop2(_i2) {
                    if (priceCategoryData.value.findIndex(function (it) {
                      return it.categoryId === pssList[_i2].categoryId && it.priceId === pssList[_i2].priceId;
                    }) < 0) {
                      priceCategoryData.value.push({
                        priceId: pssList[_i2].priceId,
                        priceName: pssList[_i2].priceName,
                        categoryId: pssList[_i2].categoryId,
                        categoryName: pssList[_i2].categoryName
                      });
                    }
                  };

                  for (var _i2 = 0; _i2 < pssList.length; _i2++) {
                    _loop2(_i2);
                  }
                })();
              }

              showPriceCategory = computed(function () {
                return priceCategoryData.value && priceCategoryData.value.length && computedDisplayedCustomFieldsType.value === CustomFieldType.TICKET;
              }); // Lets make the selected priceCategory the first item in the array priceCategoryData

              selectedPriceCategory = ref();

              if (priceCategoryData.value && priceCategoryData.value.length) {
                selectedPriceCategory.value = priceCategoryData.value[0];
              }

              displayedCustomFieldsType = ref(CustomFieldType.TICKET);

              if (bookingTypeCustomFields.value && bookingTypeCustomFields.value.length) {
                // Lets always display booking type custom fields first
                displayedCustomFieldsType.value = CustomFieldType.BOOKING;
              }

              userCurrentCountry = computed(function () {
                return POSConfigModule.groupPhoneCode || "CH";
              }); // Helper function to get country code from phone number

              getCountryCodeFromPhone = function getCountryCodeFromPhone(customField) {
                // Before checking country code from phone number answer lets check if there is an answer
                var correspondingCustomField = null;

                if (customField.type === CustomFieldType.BOOKING) {
                  correspondingCustomField = bookingTypeCustomFields.value.find(function (c) {
                    return c.uuid === customField.uuid;
                  });
                } else if (customField.type === CustomFieldType.TICKET) {
                  correspondingCustomField = groupedTicketTypeCustomFieldsByPSS.value.map(function (g) {
                    return g.customFields;
                  }).flat().find(function (c) {
                    return c.uuid === customField.uuid;
                  });
                } // If there is no such a custom field then we avoid checking for country code


                if (!correspondingCustomField) return undefined;

                if (correspondingCustomField) {
                  // If the custom field is not originally answered then we avoid checking for country code
                  // following up logic will show the user the group country for unanswered phone number custom fields
                  if (!correspondingCustomField.answer) return undefined;
                } // So there is a corresponding custom field and it has an answer


                var phoneNumber = customField.answer;
                if (!phoneNumber) return undefined;

                try {
                  var parsed = parsePhoneNumber(phoneNumber);
                  return parsed === null || parsed === void 0 ? void 0 : parsed.country;
                } catch (error) {
                  console.log("Error parsing phone number:", error);
                  return undefined;
                }
              };

              computedDisplayedCustomFieldsType = computed(function () {
                return displayedCustomFieldsType.value;
              });
              /**
               * User can confirm only if all required fields have been answered
               */

              canConfirm = computed(function () {
                var _loop3 = function _loop3(_i3) {
                  // check if:
                  // - current field is mandatory AND
                  // we have no "answer" and current field isn't a list OR
                  // we have no listAnswer and current field is a list
                  if (bookingTypeCustomFields.value[_i3].customField.validation === CustomFieldValidation.MANDATORY) {
                    if ((!bookingTypeCustomFields.value[_i3].listAnswer || !bookingTypeCustomFields.value[_i3].listAnswer.length) && bookingTypeCustomFields.value[_i3].customField.questionType === QuestionType.LIST) {
                      // This a LIST or a DROPDOWN and it doesn't have a listAnswer
                      return {
                        v: false
                      };
                    }

                    if (!bookingTypeCustomFields.value[_i3].answer && [QuestionType.LIST].findIndex(function (it) {
                      return it === bookingTypeCustomFields.value[_i3].customField.questionType;
                    }) === -1) {
                      // This is not a LIST nor a DROPDOWN and it dosn't have an answer
                      return {
                        v: false
                      };
                    }
                  }
                };

                for (var _i3 = 0; _i3 < bookingTypeCustomFields.value.length; _i3++) {
                  var _ret = _loop3(_i3);

                  if (_typeof(_ret) === "object") return _ret.v;
                }

                var _loop4 = function _loop4(_i4) {
                  // check if:
                  // - current field is mandatory AND
                  // we have no "answer" and current field isn't a list OR
                  // we have no listAnswer and current field is a list
                  if (ticketTypeCustomFields.value[_i4].customField.validation === CustomFieldValidation.MANDATORY) {
                    if ((!ticketTypeCustomFields.value[_i4].listAnswer || !ticketTypeCustomFields.value[_i4].listAnswer.length) && ticketTypeCustomFields.value[_i4].customField.questionType === QuestionType.LIST) {
                      // This a LIST or a DROPDOWN and it doesn't have a listAnswer
                      return {
                        v: false
                      };
                    }

                    if (!ticketTypeCustomFields.value[_i4].answer && [QuestionType.LIST].findIndex(function (it) {
                      return it === ticketTypeCustomFields.value[_i4].customField.questionType;
                    }) === -1) {
                      // This is not a LIST nor a DROPDOWN and it dosn't have an answer
                      return {
                        v: false
                      };
                    }
                  }
                };

                for (var _i4 = 0; _i4 < ticketTypeCustomFields.value.length; _i4++) {
                  var _ret2 = _loop4(_i4);

                  if (_typeof(_ret2) === "object") return _ret2.v;
                }

                return true;
              });
              // List of frequently selected countries
              frequentlySelectedCountries = computed(function () {
                var countries = ["DE", "US", "GB", "FR", "IT"];
                return countriesList().filter(function (country) {
                  return countries.includes(country.key);
                });
              });
              searchQuery = ref("");
              showFrequentlySelected = ref(true);

              countryFilter = function countryFilter(query) {
                searchQuery.value = query;
                showFrequentlySelected.value = query.trim() === ""; // Hide if there's a search term
              }; // Filter all countries based on search input


              filteredCountriesList = computed(function () {
                return countriesList().filter(function (country) {
                  return country.value.toLowerCase().includes(searchQuery.value.toLowerCase());
                });
              }); // Ensure frequently selected section reappears when dropdown is reopened

              handleDropdownVisibility = function handleDropdownVisibility(visible) {
                if (visible && searchQuery.value === "") {
                  showFrequentlySelected.value = true;
                }
              }; // Function to generate flag URL


              getFlagUrl = function getFlagUrl(code) {
                return "https://flagcdn.com/w20/".concat(code.toLowerCase(), ".png");
              };

              return _context3.abrupt("return", {
                t: t,
                isLoading: isLoading,
                dialogVisible: dialogVisible,
                bookingTypeCustomFields: bookingTypeCustomFields,
                ticketTypeCustomFields: ticketTypeCustomFields,
                selectBookingTypeCustomFields: selectBookingTypeCustomFields,
                selectTicketTypeCustomFields: selectTicketTypeCustomFields,
                QuestionType: QuestionType,
                InformationType: InformationType,
                countriesList: countriesList,
                languagesList: languagesList,
                userCurrentCountry: userCurrentCountry,
                canConfirm: canConfirm,
                CustomFieldValidation: CustomFieldValidation,
                displayedCustomFieldsType: displayedCustomFieldsType,
                computedDisplayedCustomFieldsType: computedDisplayedCustomFieldsType,
                CustomFieldType: CustomFieldType,
                priceCategoryData: priceCategoryData,
                selectedPriceCategory: selectedPriceCategory,
                showPriceCategory: showPriceCategory,
                selectPriceCategory: selectPriceCategory,
                groupedTicketTypeCustomFieldsByPSS: groupedTicketTypeCustomFieldsByPSS,
                handleFileUpload: handleFileUpload,
                selectedFiles: selectedFiles,
                binIcon: binIcon,
                binAlt: binAlt,
                binIconStyle: binIconStyle,
                removeFile: removeFile,
                ValidationDataType: ValidationDataType,
                isEmailValid: isEmailValid,
                canValidate: canValidate,
                confirmCroppedPicture: confirmCroppedPicture,
                cancelCroppedPicture: cancelCroppedPicture,
                getFlagUrl: getFlagUrl,
                frequentlySelectedCountries: frequentlySelectedCountries,
                countryFilter: countryFilter,
                handleDropdownVisibility: handleDropdownVisibility,
                filteredCountriesList: filteredCountriesList,
                showFrequentlySelected: showFrequentlySelected,
                getCountryCodeFromPhone: getCountryCodeFromPhone,
                stripHtml: stripHtml
              });

            case 63:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }))();
  },
  methods: {
    hideDialog: function hideDialog() {
      ModalModule.setStatus(ModalStatus.Hidden);
    },
    proceed: function proceed() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var selectedPriceCat, index, nextPriceCat;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (!(_this.displayedCustomFieldsType === CustomFieldType.BOOKING)) {
                  _context4.next = 9;
                  break;
                }

                if (!(_this.ticketTypeCustomFields && _this.ticketTypeCustomFields.length)) {
                  _context4.next = 5;
                  break;
                }

                _this.selectTicketTypeCustomFields();

                _context4.next = 7;
                break;

              case 5:
                _context4.next = 7;
                return _this.proceedAnswers();

              case 7:
                _context4.next = 20;
                break;

              case 9:
                if (!(_this.displayedCustomFieldsType === CustomFieldType.TICKET)) {
                  _context4.next = 20;
                  break;
                }

                // If we are displaying the last category then we will start processing, otherwise we display the next category
                selectedPriceCat = _this.selectedPriceCategory;
                index = _this.priceCategoryData.findIndex(function (p) {
                  return p.priceId === selectedPriceCat.priceId && p.categoryId === selectedPriceCat.categoryId;
                });

                if (!(index > -1)) {
                  _context4.next = 20;
                  break;
                }

                if (!(index === _this.priceCategoryData.length - 1)) {
                  _context4.next = 18;
                  break;
                }

                _context4.next = 16;
                return _this.proceedAnswers();

              case 16:
                _context4.next = 20;
                break;

              case 18:
                // We are not displaying the last price category, lets select the next one
                nextPriceCat = _this.priceCategoryData[index + 1];

                _this.selectPriceCategory(nextPriceCat);

              case 20:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    },
    proceedAnswers: function proceedAnswers() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                console.log("----------- hi from proceedAnswers");
                _this2.canValidate = true;

                if (_this2.canConfirm) {
                  _context5.next = 4;
                  break;
                }

                return _context5.abrupt("return");

              case 4:
                _context5.next = 6;
                return _this2.confirmAnswers();

              case 6:
                _context5.next = 8;
                return startProcessing();

              case 8:
                // 3- Hide the popup
                ModalModule.setStatus(ModalStatus.Hidden);

              case 9:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }))();
    },
    confirmAnswers: function confirmAnswers() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var bookingCopy, _loop5, i, j, _bookingCopy$pssList$, _loop6, h;

        return regeneratorRuntime.wrap(function _callee6$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                // TODO Hamza: Grab the user input as answers for questions and assign them to customFieldsAnswers in IPSB/IPSS, and update the booking
                // For date answer don't forget to convert it into isostring.
                bookingCopy = cloneDeep(BookingModule.selectedBooking);

                if (!bookingCopy) {
                  _context8.next = 24;
                  break;
                }

                if (!(bookingCopy.customFieldsAnswers && bookingCopy.customFieldsAnswers.length)) {
                  _context8.next = 10;
                  break;
                }

                _loop5 = /*#__PURE__*/regeneratorRuntime.mark(function _loop5(i) {
                  var customFieldsAnswers, file;
                  return regeneratorRuntime.wrap(function _loop5$(_context6) {
                    while (1) {
                      switch (_context6.prev = _context6.next) {
                        case 0:
                          // if (!bookingCopy.customFieldsAnswers || !bookingCopy.customFieldsAnswers[i]) continue;
                          // TODO Hamza: if answer is actually a date then we need to get its utc.isostring format and assign it to booking field answer
                          customFieldsAnswers = bookingCopy.customFieldsAnswers.find(function (c) {
                            return c.uuid === _this3.bookingTypeCustomFields[i].uuid;
                          });

                          if (!customFieldsAnswers) {
                            _context6.next = 11;
                            break;
                          }

                          customFieldsAnswers.answer = _this3.bookingTypeCustomFields[i].answer;

                          if (Array.isArray(_this3.bookingTypeCustomFields[i].listAnswer)) {
                            // So this should be a list of checkboxes answers
                            customFieldsAnswers.listAnswer = _this3.bookingTypeCustomFields[i].listAnswer;
                          } else {
                            // so this should be a dropdown/radio, we need to store its answer in 'answer' field, not 'listAnswer' field
                            customFieldsAnswers.answer = _this3.bookingTypeCustomFields[i].listAnswer;
                          } // If this field is of type file then we need the fileID field as well and insert it into the db


                          if (!(customFieldsAnswers.customField.questionType === QuestionType.FILE && _this3.bookingTypeCustomFields[i].fileID && customFieldsAnswers.fileID !== _this3.bookingTypeCustomFields[i].fileID
                          /*Because we only insert a new file in dexiedB, we don't try to insert again if no new file was uploaded*/
                          )) {
                            _context6.next = 11;
                            break;
                          }

                          // so going to confirm file
                          customFieldsAnswers.fileID = _this3.bookingTypeCustomFields[i].fileID;
                          customFieldsAnswers.fileUrl = _this3.bookingTypeCustomFields[i].fileUrl;
                          customFieldsAnswers.isCropped = _this3.bookingTypeCustomFields[i].isCropped;
                          file = _this3.selectedFiles.find(function (f) {
                            return f.id === customFieldsAnswers.fileID;
                          }).file;
                          _context6.next = 11;
                          return insertFile({
                            _id: customFieldsAnswers.fileID,
                            file: file,
                            customFieldId: customFieldsAnswers.customField.id
                          });

                        case 11:
                        case "end":
                          return _context6.stop();
                      }
                    }
                  }, _loop5);
                });
                i = 0;

              case 5:
                if (!(i < _this3.bookingTypeCustomFields.length)) {
                  _context8.next = 10;
                  break;
                }

                return _context8.delegateYield(_loop5(i), "t0", 7);

              case 7:
                i++;
                _context8.next = 5;
                break;

              case 10:
                j = 0;

              case 11:
                if (!(j < bookingCopy.pssList.length)) {
                  _context8.next = 23;
                  break;
                }

                if (!(bookingCopy.pssList[j].customFieldsAnswers && (_bookingCopy$pssList$ = bookingCopy.pssList[j].customFieldsAnswers) !== null && _bookingCopy$pssList$ !== void 0 && _bookingCopy$pssList$.length)) {
                  _context8.next = 20;
                  break;
                }

                _loop6 = /*#__PURE__*/regeneratorRuntime.mark(function _loop6(h) {
                  var _bookingCopy$pssList$2;

                  var customFieldsAnswers, file;
                  return regeneratorRuntime.wrap(function _loop6$(_context7) {
                    while (1) {
                      switch (_context7.prev = _context7.next) {
                        case 0:
                          // TODO Hamza: if answer is actually a date then we need to get its utc.isostring format and assign it to booking field answer
                          customFieldsAnswers = (_bookingCopy$pssList$2 = bookingCopy.pssList[j].customFieldsAnswers) === null || _bookingCopy$pssList$2 === void 0 ? void 0 : _bookingCopy$pssList$2.find(function (c) {
                            return c.uuid === _this3.ticketTypeCustomFields[h].uuid;
                          });

                          if (!customFieldsAnswers) {
                            _context7.next = 11;
                            break;
                          }

                          customFieldsAnswers.answer = _this3.ticketTypeCustomFields[h].answer;

                          if (Array.isArray(_this3.ticketTypeCustomFields[h].listAnswer)) {
                            // So this should be a list of checkboxes answers
                            customFieldsAnswers.listAnswer = _this3.ticketTypeCustomFields[h].listAnswer;
                          } else {
                            // so this should be a dropdown/radio, we need to store its answer in 'answer' field, not 'listAnswer' field
                            customFieldsAnswers.answer = _this3.ticketTypeCustomFields[h].listAnswer;
                          } // If this field is of type file then we need the fileID field as well and insert it into the db


                          if (!(customFieldsAnswers.customField.questionType === QuestionType.FILE && _this3.ticketTypeCustomFields[h].fileID && customFieldsAnswers.fileID !== _this3.ticketTypeCustomFields[h].fileID
                          /*Because we only insert a new file in dexiedB, we don't try to insert again if no new file was uploaded*/
                          )) {
                            _context7.next = 11;
                            break;
                          }

                          customFieldsAnswers.fileID = _this3.ticketTypeCustomFields[h].fileID;
                          customFieldsAnswers.fileUrl = _this3.ticketTypeCustomFields[h].fileUrl;
                          customFieldsAnswers.isCropped = _this3.ticketTypeCustomFields[h].isCropped;
                          file = _this3.selectedFiles.find(function (f) {
                            return f.id === customFieldsAnswers.fileID;
                          }).file;
                          _context7.next = 11;
                          return insertFile({
                            _id: customFieldsAnswers.fileID,
                            file: file,
                            customFieldId: customFieldsAnswers.customField.id
                          });

                        case 11:
                        case "end":
                          return _context7.stop();
                      }
                    }
                  }, _loop6);
                });
                h = 0;

              case 15:
                if (!(h < _this3.ticketTypeCustomFields.length)) {
                  _context8.next = 20;
                  break;
                }

                return _context8.delegateYield(_loop6(h), "t1", 17);

              case 17:
                h++;
                _context8.next = 15;
                break;

              case 20:
                j++;
                _context8.next = 11;
                break;

              case 23:
                BookingModule.updateBooking(bookingCopy);

              case 24:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee6);
      }))();
    }
  }
});